var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"contacts"},[_vm._t("contacts")],2),_c('div',{staticClass:"categories"},[_vm._t("categories")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }